import autoBind from 'react-autobind';
import RetinaImage from 'react-retina-image';

import React, {Component, PropTypes} from 'react';

export default class DashboardCharacter extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  render() {
    const {
      characterId,
      characterName,
      characterFoundation,
      characterImageName,
      selected,
      onSelect
    } = this.props;

    return (
      <div className={`dashboard-character ${selected ? 'selected' : 'not-selected'} ${characterName}`} onClick={onSelect} data-id={characterId}>
        <RetinaImage src={require(`../images/${characterImageName || 'img-nopic'}@2x.png`)} />
        <div className="name">{characterName}</div>
        <div className="foundation">{characterFoundation}</div>
      </div>
    );
  }
}

DashboardCharacter.propTypes = {
  characterFoundation: PropTypes.string,
  characterId: PropTypes.number,
  characterImageName: PropTypes.string,
  characterName: PropTypes.string,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/features/dashboard/components/DashboardCharacter.js